/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'utils/hooks';

import { accessCheck } from 'utils/HOC/protector';
import { NotificationTypeEnum, UserRoleEnum } from 'utils/types.d';
import { getSoundTypes } from 'utils/helpers';

import config from 'config';
import logoImage from 'ui/images/newLogo.svg';

import StyledHeader from './Header.style';
import UserMenu from './components/UserMenu';
import Bell from './components/Bell';
import CompanyChooser from './components/CompanyChooser';
import OnlineToggle from './components/OnlineToggle/OnlineToggle';

const Header: React.FC = () => {
  const { i18n } = useTranslation();
  const lang = useAppSelector(({ main }) => main.lang);
  const user = useAppSelector(({ main }) => main?.user);
  const notificationsList = useAppSelector(({ notificationsList }) => notificationsList.notificationsList);
  useEffect(() => {
    (() => i18n.changeLanguage(lang))();
  }, [i18n, lang]);

  // the client asked to temporarily hide this functionality
  // const changeLang = useCallback(
  //   (e) => {
  //     dispatch(changeLanguage(e.target.innerHTML));
  //   },
  //   [dispatch],
  // );

  return (
    <StyledHeader>

      <div className="user-block">
        <UserMenu />
        {/* temporary hidden */}
        {/* {accessCheck(user, [UserRoleEnum.HRD, UserRoleEnum.Manager, UserRoleEnum.Recruiter]) && (
          <OnlineToggle />
        )}
        )} */}
        {user && (
          // <Bell notificationsList={notificationsList} isVisibleCounter={false} />
          <Bell
            notificationsList={notificationsList}
            counterVisibleTypes={getSoundTypes(user.role)}
            isVisibleCounter={user.role === UserRoleEnum.Admin}
          />
        )}
        {user?.isSubclient && <CompanyChooser />}
        {/* <div className="language">
          <Button disabled={lang === 'ru'} onClick={changeLang}>
            ru
          </Button>
          <Button disabled={lang === 'en'} onClick={changeLang}>
            en
          </Button>
        </div> */}
      </div>
      <div className='logo-link'>
        <a href={config.baseUrl} >
          <img src={logoImage} alt="logo" />
        </a>
      </div>
    </StyledHeader>
  );
};

export default memo(Header);
